import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { SortParams, SortParamsArg } from 'shared/models/common';
import { Activeness, RelatedTo } from './enums';
import { DEFAULT_SORTING_KEY } from './constants';
import { MeterIndication } from './models';

interface MeterReadingState {
  activeness: Activeness;
  readingDate: Date | null;
  readyMeters: MeterIndication[];
  relatedTo: RelatedTo;
  searchTerm: string;
  sortParams: SortParams;
}

const initialState: MeterReadingState = {
  activeness: Activeness.Active,
  readingDate: new Date(),
  readyMeters: [],
  relatedTo: RelatedTo.Both,
  searchTerm: '',
  sortParams: {
    order: 'asc',
    orderBy: DEFAULT_SORTING_KEY,
    type: 'string',
  },
};

export const meterReadingSlice = createSlice({
  name: 'meterReading',
  initialState,
  reducers: {
    changeActiveness: (state, action: PayloadAction<Activeness>) => {
      state.activeness = action.payload;
    },
    changeReadingDate: (state, action: PayloadAction<Date | null>) => {
      state.readingDate = action.payload;
    },
    changeRelatedToField: (state, action: PayloadAction<RelatedTo>) => {
      state.relatedTo = action.payload;
    },
    changeSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    changeSortParams: (state, action: PayloadAction<SortParamsArg>) => {
      state.sortParams = {
        order: state.sortParams.order === 'asc' ? 'desc' : 'asc',
        orderBy: action.payload.id,
        type: action.payload.type,
      };
    },
    addReadyMeter: (state, action: PayloadAction<MeterIndication>) => {
      state.readyMeters.push(action.payload);
    },
    removeReadyMeter: (state, action: PayloadAction<string>) => {
      state.readyMeters = state.readyMeters.filter(
        (meter) => meter.MeterId !== action.payload
      );
    },
  },
});

export const {
  changeActiveness,
  changeReadingDate,
  changeRelatedToField,
  changeSearchTerm,
  changeSortParams,
  addReadyMeter,
  removeReadyMeter,
} = meterReadingSlice.actions;
export default meterReadingSlice.reducer;
